module.exports = __webpack_public_path__ + "img/parity-substrate.18f6a8ee.png";